import React from 'react';
import { Play, GraduationCap, CheckCircle } from 'lucide-react';
import { G1, GG, NavyBg, PAGE_ROOT, OR } from '../../config/styles';
import { apiUrl } from '../../config/supabase';

// 🤖 حالة اشتراك المساعد الذكي (جنب حساب العميل)
function BotAccessCard({ customer, onSetPage }) {
  const [me, setMe] = React.useState(null);
  React.useEffect(() => {
    let token = ''; try { token = localStorage.getItem('cust_token') || ''; } catch {}
    if (!token) return;
    fetch(apiUrl('/api/bot/me'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token }) })
      .then(r => r.json()).then(j => j && j.ok && setMe(j)).catch(() => {});
  }, [customer?.id]);
  if (!me) return null;
  const open = me.state === 'open';
  return (
    <div style={{ maxWidth: 720, margin: '0 auto 22px', background: 'rgba(255,255,255,0.06)', border: `1px solid ${open ? (me.days_left <= 30 ? 'rgba(249,115,22,0.6)' : 'rgba(74,222,128,0.5)') : 'rgba(248,113,113,0.5)'}`, borderRadius: 16, padding: '14px 18px', color: 'white', display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', backdropFilter: 'blur(8px)' }}>
      <span style={{ fontSize: 26 }}>🤖</span>
      <div style={{ flex: 1, minWidth: 200 }}>
        <div style={{ fontWeight: 'bold', fontSize: 14 }}>{open ? `المساعد الذكي — باقي ${me.days_left} يوم` : me.state === 'expired' ? 'اشتراك المساعد الذكي انتهى' : 'المساعد الذكي — مش مفعّل'}</div>
        <div style={{ fontSize: 12, opacity: 0.75 }}>{me.access_until ? `${open ? 'ينتهي' : 'انتهى'} ${new Date(me.access_until).toLocaleDateString('ar-EG')}` : ''}{me.telegram_linked ? ' · 📱 تليجرام مربوط' : ''}</div>
      </div>
      {(!open || me.days_left <= 30) && (
        <button onClick={() => onSetPage('bot-subscribe')} style={{ background: 'linear-gradient(135deg,#f97316,#fb923c)', color: 'white', border: 'none', borderRadius: 999, padding: '8px 16px', fontWeight: 'bold', cursor: 'pointer', fontSize: 13 }}>🔄 {open ? 'جدّد الاشتراك' : 'اشترك في المساعد'}</button>
      )}
    </div>
  );
}

export function MyCourses({ customer, enrollments, courses, lessons, lang, t, onSetPage, onGoPlayer, courseProgress, isWatched }) {
  const ar = lang === 'ar';
  const myEnr = enrollments.filter(e => e.customer_id === customer?.id && e.status === 'active');

  const cLessons = (cid) =>
    lessons.filter(l => l.course_id === cid).sort((a, b) => a.order_num - b.order_num);

  return (
    <div style={PAGE_ROOT}>
      <NavyBg />

      <div style={{ textAlign: 'center', color: 'white', marginBottom: '28px', animation: 'fadeInDown .6s ease both' }}>
        <h2 style={{ fontSize: '38px', fontWeight: 'bold', textShadow: '2px 2px 12px rgba(0,0,0,0.25)' }}>📚 {t.myCoursesTitle}</h2>
        {myEnr.length > 0 && (
          <p style={{ color: 'rgba(255,255,255,0.78)', fontSize: '15px', marginTop: '6px' }}>
            {myEnr.length} {ar ? 'كورس مشترك فيه' : 'enrolled courses'}
          </p>
        )}
      </div>

      <BotAccessCard customer={customer} onSetPage={onSetPage} />

      {!myEnr.length ? (
        <div style={{ textAlign: 'center', background: 'rgba(255,255,255,0.05)', borderRadius: '20px', padding: '54px 24px', backdropFilter: 'blur(10px)', border: '1px solid rgba(255,255,255,0.1)', maxWidth: '460px', margin: '0 auto', animation: 'cardRise .55s ease both' }}>
          <div style={{ fontSize: '60px', marginBottom: '14px' }}>📚</div>
          <p style={{ color: 'white', fontSize: '16px', marginBottom: '20px' }}>{t.noEnrolledCourses}</p>
          <button onClick={() => onSetPage('academy')}
            style={{ padding: '12px 26px', background: 'linear-gradient(135deg,#f97316,#fb923c)', color: 'white', border: 'none', borderRadius: '12px', fontSize: '14px', fontWeight: 'bold', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '6px', boxShadow: '0 6px 18px rgba(249,115,22,0.4)' }}>
            <GraduationCap size={16} /> {t.browseCoursesBtn}
          </button>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))', gap: '20px' }}>
          {myEnr.map((enr, index) => {
            const course = courses.find(c => c.id === enr.course_id);
            if (!course) return null;
            const cl         = cLessons(course.id);
            const pct        = courseProgress(course.id, lessons);
            const done       = cl.filter(l => isWatched(l.id)).length;
            const isComplete = pct === 100;

            return (
              <div key={enr.id} style={{ animation: 'cardRise .55s cubic-bezier(.22,1,.36,1) both', animationDelay: `${(index % 9) * 0.07}s` }}>
                <div className="gw-card" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.09)', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.3)' }}>

                  {/* Header */}
                  <div style={{ background: isComplete ? GG : G1, padding: '22px', position: 'relative', overflow: 'hidden' }}>
                    <div style={{ position: 'absolute', top: '-15px', [ar ? 'left' : 'right']: '-15px', fontSize: '72px', opacity: 0.14 }}>{course.icon}</div>
                    {isComplete && (
                      <div style={{ position: 'absolute', top: '10px', [ar ? 'right' : 'left']: '10px', background: 'rgba(255,255,255,0.22)', borderRadius: '8px', padding: '3px 8px', fontSize: '11px', color: 'white', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <CheckCircle size={11} /> {ar ? 'مكتمل 🎉' : 'Completed 🎉'}
                      </div>
                    )}
                    <div style={{ fontSize: '36px', marginBottom: '8px' }}>{course.icon}</div>
                    <h3 style={{ color: 'white', fontSize: '16px', fontWeight: 'bold', margin: 0, textShadow: '0 1px 4px rgba(0,0,0,0.3)' }}>{ar ? course.name_ar : course.name_en}</h3>
                    <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '11px', marginTop: '4px' }}>{cl.length} {t.lessons}</div>
                  </div>

                  {/* Progress */}
                  <div style={{ padding: '16px' }}>
                    <div style={{ marginBottom: '14px' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                        <span style={{ fontSize: '12px', color: 'rgba(255,255,255,0.65)', fontWeight: 'bold' }}>
                          {ar ? 'تقدمك' : 'Your Progress'}
                        </span>
                        <span style={{ fontSize: '13px', fontWeight: 'bold', color: isComplete ? '#34d399' : '#fb923c' }}>
                          {pct}% — {done}/{cl.length}
                        </span>
                      </div>
                      <div style={{ height: '8px', background: 'rgba(255,255,255,0.1)', borderRadius: '99px', overflow: 'hidden' }}>
                        <div style={{ height: '100%', background: isComplete ? GG : 'linear-gradient(135deg,#f97316,#fb923c)', width: `${pct}%`, borderRadius: '99px', transition: 'width .6s ease' }} />
                      </div>
                    </div>

                    {/* Lesson list */}
                    <div style={{ maxHeight: '160px', overflowY: 'auto', marginBottom: '14px' }}>
                      {cl.map((lesson, idx) => {
                        const watched = isWatched(lesson.id);
                        return (
                          <div key={lesson.id} onClick={() => onGoPlayer(course, lesson)}
                            style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '7px 8px', borderRadius: '8px', cursor: 'pointer', transition: 'background .15s' }}
                            onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.06)'}
                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                            <div style={{ width: '22px', height: '22px', borderRadius: '50%', background: watched ? GG : 'rgba(249,115,22,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, transition: 'all .2s' }}>
                              {watched
                                ? <CheckCircle size={12} color="white" />
                                : <span style={{ fontSize: '10px', color: '#fb923c', fontWeight: 'bold' }}>{idx + 1}</span>}
                            </div>
                            <span style={{ fontSize: '12px', color: watched ? '#34d399' : 'rgba(255,255,255,0.82)', flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontWeight: watched ? '600' : 'normal' }}>
                              {ar ? lesson.title_ar : lesson.title_en}
                            </span>
                            <Play size={10} color="rgba(255,255,255,0.45)" />
                          </div>
                        );
                      })}
                    </div>

                    {/* CTA */}
                    <button onClick={() => {
                      const nextLesson = cl.find(l => !isWatched(l.id)) || cl[0];
                      onGoPlayer(course, nextLesson);
                    }}
                      style={{ width: '100%', padding: '11px', background: isComplete ? GG : 'linear-gradient(135deg,#f97316,#fb923c)', color: 'white', border: 'none', borderRadius: '10px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', boxShadow: `0 5px 14px ${isComplete ? 'rgba(16,185,129,0.4)' : 'rgba(249,115,22,0.4)'}` }}>
                      <Play size={13} />
                      {isComplete
                        ? (ar ? 'مراجعة الكورس 🔄' : 'Review Course 🔄')
                        : pct > 0 ? t.continueLearning : t.startLearning}
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <div style={{ textAlign: 'center', marginTop: '30px' }}>
        <button onClick={() => onSetPage('home')}
          style={{ padding: '11px 26px', background: 'rgba(255,255,255,0.95)', color: OR, border: 'none', borderRadius: '10px', fontSize: '14px', cursor: 'pointer', fontWeight: 'bold', boxShadow: '0 4px 16px rgba(0,0,0,0.18)' }}>
          {t.backHome}
        </button>
      </div>
    </div>
  );
}
